/* me-signup.js — Melrose Essentials list growth (board item 8), Viktor 2026-09-10.
 *
 * Every email capture on the site (footer "Stay Connected" block and the theme's
 * sign-up modal) is Shopify's {% form 'customer' %}. Those posts go to Shopify, sit
 * behind Shopify's invisible hCaptcha, and only reach Klaviyo through the Shopify
 * integration's customer sync — which is not what the LIVE Welcome flow triggers on
 * (it triggers on being added to Klaviyo list Tvs4YX).
 *
 * So we intercept the submit and post straight to Klaviyo's client subscription API
 * with the site's public key. Result: a SUBSCRIBED profile on Tvs4YX, consent
 * timestamped by Klaviyo, Welcome flow fires immediately, and the visitor is also
 * identified to the onsite tracker so browse/checkout abandonment can reach them.
 */
(function () {
  var COMPANY_ID = 'YcvaEy';
  var LIST_ID = 'Tvs4YX';
  var ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + COMPANY_ID;
  var OFFER =
    'Join the list and I\u2019ll send you a $10 code for your first jar. \u2014 Brett, Founder';
  var CONSENT =
    'By signing up you agree to receive email from Melrose Essentials. ' +
    'Unsubscribe any time \u2014 every email has a one-click link.';

  function valid(email) {
    return /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(email);
  }

  function subscribe(email, source) {
    return fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'content-type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: { email: email } } },
            custom_source: source
          },
          relationships: { list: { data: { type: 'list', id: LIST_ID } } }
        }
      })
    });
  }

  function message(form, text, ok) {
    var el = form.querySelector('.me-signup-msg');
    if (!el) {
      el = document.createElement('p');
      el.className = 'me-signup-msg';
      el.setAttribute('role', 'status');
      // Sit directly under the button, ABOVE the consent fine print — otherwise the good
      // news lands below the legal line and reads like an afterthought.
      var consent = form.querySelector('.me-signup-consent');
      if (consent) {
        form.insertBefore(el, consent);
      } else {
        form.appendChild(el);
      }
    }
    // Explicit px: this theme sets html{font-size:62.5%} so 1rem renders as 10px and any
    // rem sizing here comes out about a third too small.
    var base =
      'margin:12px 0 0;line-height:1.45;max-width:42ch;' +
      'font-size:' + (ok ? '20px' : '16px') + ';font-weight:' + (ok ? '600' : '400') + ';';
    // Success gets the same navy-rule treatment as /pages/clinic-guests so the two
    // capture points look like the same brand. On the dark footer the tint is invisible,
    // so the rule carries it there.
    el.style.cssText = ok
      ? base +
        'padding:14px 16px;border-left:4px solid currentColor;' +
        'background:rgba(37,59,96,.06);border-radius:0 4px 4px 0;'
      : base;
    el.style.color = ok ? 'inherit' : '#a8331f';
    el.textContent = text;
  }

  function addOffer(form) {
    if (form.querySelector('.me-signup-offer')) return;
    var p = document.createElement('p');
    p.className = 'me-signup-offer';
    p.style.cssText =
      'margin:0 0 0.75rem;font-size:1.45rem;line-height:1.45;max-width:42ch;';
    p.textContent = OFFER;
    // The footer block puts its "Stay Connected" heading INSIDE the form, so a naive
    // insertBefore(firstChild) lands the offer above the heading. Sit under the heading.
    var heading = null;
    var kids = form.children;
    for (var i = 0; i < kids.length; i++) {
      if (/^(H[1-6])$/.test(kids[i].tagName)) heading = kids[i];
    }
    if (heading) {
      form.insertBefore(p, heading.nextSibling);
    } else {
      form.insertBefore(p, form.firstChild);
    }
  }

  function addConsent(form) {
    if (form.querySelector('.me-signup-consent')) return;
    var p = document.createElement('p');
    p.className = 'me-signup-consent';
    p.style.cssText =
      'margin:0.6rem 0 0;font-size:1.15rem;line-height:1.4;opacity:0.7;max-width:42ch;';
    p.textContent = CONSENT;
    form.appendChild(p);
  }

  function inModal(form) {
    return !!form.closest('.modal, dialog, [id*="modal" i], [id*="SignupModal" i]');
  }

  function wire(form) {
    if (form.dataset.meSignup) return;
    form.dataset.meSignup = '1';
    // The popup already carries the offer in its own copy; only the footer needs the line.
    if (!inModal(form)) addOffer(form);
    addConsent(form);

    form.addEventListener(
      'submit',
      function (event) {
        event.preventDefault();
        event.stopPropagation();

        var input = form.querySelector("input[type='email']");
        var button = form.querySelector("button[type='submit']");
        var email = input ? (input.value || '').trim() : '';

        if (!valid(email)) {
          message(form, 'That email address does not look right \u2014 mind checking it?', false);
          if (input) input.focus();
          return;
        }

        var source = inModal(form) ? 'Site popup' : 'Footer signup';
        if (button) {
          button.disabled = true;
          button.dataset.meLabel = button.textContent;
          button.textContent = 'Signing you up\u2026';
        }

        subscribe(email, source)
          .then(function (response) {
            if (response.status === 202 || response.ok) {
              try {
                window._learnq = window._learnq || [];
                window._learnq.push(['identify', { $email: email }]);
              } catch (e) {}
              if (input) input.value = '';
              message(
                form,
                "You're in \u2014 your personal $10 code is on its way to your inbox. " +
                  'Check your email in a minute or two.',
                true
              );
              if (button) {
                button.textContent = 'Thank you';
              }
              return;
            }
            throw new Error('HTTP ' + response.status);
          })
          .catch(function () {
            message(
              form,
              "That didn't go through. Email brett@melroseessentials.com and I'll add you by hand.",
              false
            );
            if (button) {
              button.disabled = false;
              button.textContent = button.dataset.meLabel || 'Subscribe';
            }
          });
      },
      true
    );
  }

  function wireAll() {
    document.querySelectorAll('form.newsletter-form').forEach(wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wireAll);
  } else {
    wireAll();
  }
  // The sign-up modal and some sections render late; catch them as they appear.
  new MutationObserver(wireAll).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
